import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CustomTextGetQueryResult, EContentLocation } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { CustomText } from './custom-text.model';
import { ICustomTextService, ICustomTextServiceToken } from 'projects/shared/lib/services/data/custom-text/custom-text-service.interface';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';

@Component({
    selector: 'app-custom-text',
    imports: [],
    templateUrl: './custom-text.component.html',
    styleUrls: ['./custom-text.component.scss']
})
export class CustomTextComponent implements OnInit, OnChanges {
  @Input() public customTextParam: CustomText | undefined;
  @Input() public embeddInCard?: boolean | undefined;

  public eContentLocation: typeof EContentLocation = EContentLocation;

  public customTextTrustedHTML: SafeHtml | undefined;
  public customTextName: string | undefined;

  private readonly customTextService: ICustomTextService;
  private sanitizer: DomSanitizer;

  public constructor() {
    this.customTextService = inject(ICustomTextServiceToken);
    this.sanitizer = ServiceLocator.injector.get(DomSanitizer);
  }

  public ngOnInit(): void {
    if (this.customTextParam) {
      this.customTextLoad(this.customTextParam);
    } else {
      this.customTextTrustedHTML = undefined;
    }
  }

  public async ngOnChanges(changes: SimpleChanges): Promise<void> {
    for (let propName in changes) {
      let change = changes[propName];
      switch (propName) {
        case 'customTextParam':
          break;
        default: {
          throw new Error('Input property handler not implemented.');
        }
      }

      if (!change) {
        this.customTextTrustedHTML = undefined;
      }

      let customText: CustomText = change.currentValue as CustomText;

      this.customTextLoad(customText);
    }
  }


  private customTextLoad(customText: CustomText) {
    this.customTextName = customText.name;
    this.customTextService.customTextGet(customText.type, customText.group, customText.name).then(
      (customTextGetQueryResult: CustomTextGetQueryResult) => {
        if (customTextGetQueryResult) {
          let webtext = customTextGetQueryResult.webText;
          if (webtext == undefined) {
            return;
          }
          this.customTextTrustedHTML = this.sanitizer.bypassSecurityTrustHtml(webtext);
        }
      }
    );
  }

}
